import { useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { useNavbarStore } from 'components/Layout/navbar-store'
import { Tabs } from 'components/FbUI/Tabs'

import { DistributorTable } from 'features/settings/components/DistributorTable'
import { MiscSettingsTable } from 'features/settings/components/MiscSettingsTable'
import { SalesStageTable } from 'features/settings/components/SalesStageTable'
import { SavedFiltersTable } from 'features/settings/components/SavedFiltersTable'
import { ColumnPresetsTable } from 'features/settings/components/ColumnPresetsTable'
import { UserTable } from 'features/settings/components/UserTable'
import { EmailIntegrationTable } from 'features/settings/components/EmailIntegrationTable'
import { Account } from 'features/settings/components/Account'
import { TabGroupKeys, TabKeys } from 'features/settings/components/SideMenu'
import { TagTable } from 'features/settings/components/TagTable'
import { useAuth } from 'context/authentication/useAuth'
import { CompanyDomainsTable } from 'features/settings/components/CompanyDomainsTable'
import { NotificationPreferencesTable } from 'features/settings/components/NotificationPreferencesTable'
import { GPOTable } from 'features/settings/components/GPOTable'
import { AutomationsTable } from 'features/settings/components/AutomationsTable'
import { Logo } from 'features/settings/components/Logo'
import { SenderEmailSettings } from 'features/settings/components/SenderEmailSettings'
import { useSideMenu } from 'features/settings/context/SideMenuContext'
import { featureFlagService } from 'utils/featureFlagService'

export function Settings() {
  const params = useParams()
  const group = (params?.group ?? 'users') as TabGroupKeys
  const tab = (params?.tab ?? 'users') as TabKeys
  const { tabGroups } = useSideMenu()
  const currentGroup = tabGroups[group]
  const navigate = useNavigate()
  const { setLastSettingsVisited } = useNavbarStore()
  const { user } = useAuth()
  const featureFlags = featureFlagService()

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageInnerTabsContainer>
        <Tabs
          tabs={
            currentGroup
              ? Object.values(currentGroup?.tabs)
                  .filter((tab) => tab.isAllowed(user, featureFlags))
                  .map((tab) => ({
                    key: tab.uri,
                    title: tab.title,
                  }))
              : []
          }
          selectedTab={tab}
          setSelectedTab={(value) => {
            const url = `/settings/${currentGroup.uri}/${value}`
            navigate(url)
            setLastSettingsVisited(url)
          }}
          tabStyle={{ width: '125px' }}
        />
      </FBPageInnerTabsContainer>
      <FBPageTableContainer hide={tab !== 'users'}>
        <UserTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== ('logo' as TabKeys)}>
        <Logo />
      </FBPageTableContainer>

      <FBPageTableContainer hide={tab !== 'sales-stages'}>
        <SalesStageTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'filters'}>
        <SavedFiltersTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'columns'}>
        <ColumnPresetsTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'distributors'}>
        <DistributorTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'gpos'}>
        <GPOTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'product-tags'}>
        <TagTable tagParent="products" />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'contact-tags'}>
        <TagTable tagParent="contacts" />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'document-tags'}>
        <TagTable tagParent="documents" />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'email-integration'}>
        <EmailIntegrationTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'misc'}>
        <MiscSettingsTable />
      </FBPageTableContainer>
      {user?.is_billing_admin && (
        <FBPageTableContainer hide={tab !== 'account'}>
          <Account />
        </FBPageTableContainer>
      )}

      <FBPageTableContainer hide={tab !== 'domains'}>
        <CompanyDomainsTable />
      </FBPageTableContainer>

      <FBPageTableContainer hide={group !== 'notifications'}>
        <NotificationPreferencesTable tab={tab} />
      </FBPageTableContainer>

      <FBPageTableContainer hide={tab !== 'automations'}>
        <AutomationsTable />
      </FBPageTableContainer>

      <FBPageTableContainer hide={tab !== 'sender-emails'}>
        <SenderEmailSettings />
      </FBPageTableContainer>
    </div>
  )
}
